import { useEffect, useState } from 'react';
import { apiGet, useApi } from '../../lib/api';

type Game = {
  game_id: string;
  season: string;
  opponent: string;
  game_date: string;
  kickoff_time: string | null;
  week_number: number | null;
};

export default function AdminGames() {
  const api = useApi();
  const [games, setGames] = useState<Game[]>([]);
  const [form, setForm] = useState({
    season: '2026',
    opponent: '',
    game_date: '',
    kickoff_time: '13:00',
    week_number: 1,
  });

  async function refresh() {
    const { games } = await apiGet<{ games: Game[] }>('/games');
    setGames(games);
  }
  useEffect(() => {
    refresh().catch(console.error);
  }, []);

  async function create(e: React.FormEvent) {
    e.preventDefault();
    await api('/admin/games', { method: 'POST', body: JSON.stringify(form) });
    setForm({ ...form, opponent: '', game_date: '' });
    await refresh();
  }

  return (
    <section>
      <h2>Games</h2>
      <form className="card" onSubmit={create} style={{ marginBottom: '1.5rem', maxWidth: 560 }}>
        <h3>Add game</h3>
        <label>
          <span>Season</span>
          <input
            required
            value={form.season}
            onChange={(e) => setForm({ ...form, season: e.target.value })}
          />
        </label>
        <label>
          <span>Opponent</span>
          <input
            required
            value={form.opponent}
            onChange={(e) => setForm({ ...form, opponent: e.target.value })}
          />
        </label>
        <label>
          <span>Date</span>
          <input
            required
            type="date"
            value={form.game_date}
            onChange={(e) => setForm({ ...form, game_date: e.target.value })}
          />
        </label>
        <label>
          <span>Kickoff (24h)</span>
          <input
            value={form.kickoff_time}
            onChange={(e) => setForm({ ...form, kickoff_time: e.target.value })}
          />
        </label>
        <label>
          <span>Week #</span>
          <input
            type="number"
            value={form.week_number}
            onChange={(e) => setForm({ ...form, week_number: Number(e.target.value) })}
          />
        </label>
        <button>Add game</button>
      </form>

      <div className="grid cols-3">
        {games.map((g) => (
          <div className="card" key={g.game_id}>
            <p>
              <strong>{g.opponent}</strong>
            </p>
            <p className="muted">
              Week {g.week_number} · {g.game_date} {g.kickoff_time && `· ${g.kickoff_time}`}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
